import { Button } from '@mui/material'

import { IonInformationModal } from '@/components/organisms/functionals'
import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

type Props = {
  loading: boolean
  open: boolean
  onClose: () => void
  count?: number
  price?: number
  onConfirm: () => Promise<void>
}
/**
 * @description
 * チケット購入時に表示するモーダル
 */
export const ConfirmTicketChargeModal: Organism<Props> = ({
  loading,
  open,
  count,
  price,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation('gachaDetail')
  return (
    <IonInformationModal
      open={open}
      onClose={onClose}
      title={t('purchaseConfirmTitle')}
      content={t('purchaseConfirmDesc', { count, price })}
      cancelText={t('cancel')}
      buttons={
        <Button
          loading={loading}
          sx={{ minWidth: 212 }}
          variant="contained"
          color="primary"
          size="large"
          onClick={onConfirm}
        >
          {t('toBuy')}
        </Button>
      }
    />
  )
}
